import * as React from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  white?: boolean;
  panelPadding?: number;
  centerContent?: boolean;
}

const RightPanel = styled.div`
  position: relative;
  text-align: center;
  box-sizing: border-box;
  flex: 1 1 40%;
  height: 100%;
  ${({ white, panelPadding = 4, centerContent }: IProps) => `
    padding: ${panelPadding}vh;
    background: ${white ? theme.color.white : theme.color.tertiary};
    ${centerContent &&
      `
      display: flex;
      justify-content: center;
    `}
  `};
`;

export default RightPanel;



// WEBPACK FOOTER //
// ./src/components/common/RightLeftLayout/Panels/RightPanel.tsx